'use strict'

// Who may build on an account, and who may open billing.
// A missing role is the owner. Older sessions were created before seats existed.

const SEAT_ROLES = ['designer', 'billing']

function normalizeSeatEmail (value) {

  const email = String(value == null ? '' : value).trim().toLowerCase()

  if (!email || email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {

    return ''
  }

  return email
}

function normalizeSeatRole (value) {

  const role = seatRole(value)

  return SEAT_ROLES.indexOf(role) === -1 ? '' : role
}

function knownAccountRole (value) {

  const role = seatRole(value)

  if (role === 'owner' || role === 'designer' || role === 'billing') return role

  return 'owner'
}

function seatRole (value) {

  const role = String(value == null ? '' : value).trim().toLowerCase()

  if (role === 'builder') return 'designer'

  return role
}

function sessionRole (owner) {

  if (!owner || typeof owner !== 'object') return ''

  if (owner.support === true) return 'owner'

  if (!owner.role) return 'owner'

  return knownAccountRole(owner.role)
}

function canOpenDesigner (role) {

  return role === 'owner' || role === 'designer' || role === 'billing'
}

function canOpenBilling (role) {

  return role === 'owner' || role === 'billing'
}

function canManageSeats (role) {

  return role === 'owner' || role === 'billing'
}

function canEditAccount (role) {

  return role === 'owner'
}

function presentSeat (seat) {

  if (!seat) return null

  return {
    email: seat.email,
    role: normalizeSeatRole(seat.role),
    invitedAt: seat.invitedAt || ''
  }
}

function presentMembership (account, role) {

  if (!account || !account.name || account.deleted === true) return null

  return {
    name: account.name,
    hostname: account.hostname || '',
    role: knownAccountRole(role)
  }
}

module.exports = {
  SEAT_ROLES,
  normalizeSeatEmail,
  normalizeSeatRole,
  knownAccountRole,
  sessionRole,
  canOpenDesigner,
  canOpenBilling,
  canManageSeats,
  canEditAccount,
  presentSeat,
  presentMembership
}
